import MinusIcon from "../../../assets/icons/minus-icon.svg"
import PlusIcon from "../../../assets/icons/plus-icon.svg"
import { useEffect, useState, forwardRef } from "react"

interface INumberStepper {
    value: number | undefined | null,
    OnChange: Function,
    Label: string,
    step: number
    min?: number,
    max?: number,
    inputClassName?: string | undefined,
    required?: boolean | undefined,
    tabIndex?: number,
    autoFocus?: boolean
    autocomplete?: string
    name?: string
}

const NumberStepper = forwardRef<HTMLInputElement, INumberStepper>(({ value, OnChange, Label, step, min, max, inputClassName, required, tabIndex, autoFocus, autocomplete, name }, ref) => {
    const [number, setNumber] = useState<number | undefined | null>(value)

    function stepUp() {
        const currentValue = number ?? 0;
        if (max === undefined || currentValue + step <= max) {
            const newValue = currentValue + step;
            setNumber(newValue);
            OnChange(newValue);
        }
    }

    function stepDown() {
        const currentValue = number ?? 0;
        if (min === undefined || currentValue - step >= min) {
            const newValue = Math.max(currentValue - step, min ?? 0);
            setNumber(newValue);
            OnChange(newValue);
        }
    }

    function handleInputChange(e: React.ChangeEvent<HTMLInputElement>) {
        const newValue = e.target.value ? parseInt(e.target.value) : undefined;
        if(newValue === null || newValue === undefined) {
            setNumber(null);
            OnChange(newValue);
            return;
        }
        if ((min === undefined || newValue >= min) && (max === undefined || newValue <= max)) {
            setNumber(newValue);
            OnChange(newValue);
            return;
        }
    }

    function handleFocus(e: React.ChangeEvent<HTMLInputElement>) {
        e.target.select();
    };

    function handleClick(e: React.MouseEvent<HTMLInputElement>) {
        e.currentTarget.select();
    };

    useEffect(() => {
        setNumber(value);
    }, [value])

    return (
        <div className="number-stepper__outer-wrapper">
            <div className="number-stepper__wrapper">
                <p className="small margin_left--xxxs">{required ? `${Label} (required)` : Label}</p>
                <div className="number-stepper__button-wrapper" onClick={() => stepDown()}>
                    <img src={MinusIcon} />
                </div>
                <div className="number-stepper__number-wrapper">
                    <input
                        ref={ref}
                        onFocus={handleFocus}
                        onClick={handleClick}
                        className={`number-stepper__number-input ${inputClassName ?? ''}`}
                        type="number"
                        value={number ?? ''}
                        onChange={handleInputChange}
                        tabIndex={tabIndex}
                        autoFocus={autoFocus}
                    />
                </div>
                <div className="number-stepper__button-wrapper" onClick={() => stepUp()}>
                    <img className="number-stepper__button-wrapper" src={PlusIcon} />
                </div>
            </div>
        </div>
    )
});

export default NumberStepper;